import { render, staticRenderFns } from "./CBBXL.vue?vue&type=template&id=7f5d6077&scoped=true&"
import script from "./CBBXL.vue?vue&type=script&lang=js&"
export * from "./CBBXL.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./CBBXL.vue?vue&type=style&index=0&id=7f5d6077&prod&scoped=true&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "7f5d6077",
  null
  ,true
)

export default component.exports